// src/version.js
/* global __APP_VERSION__, __APP_LAST_UPDATED__ */
export const APP_VERSION = __APP_VERSION__;
export const APP_LAST_UPDATED = __APP_LAST_UPDATED__;
